export default __webpack_public_path__ + "static/media/blacklist.3f237e03.svg";